import { BandWorkspace, ExplorerItemId, Segment, TagOption } from "@/types/types.ts";
import fetchInstance from "@/services/fetch.ts";

export async function shareSegment(
  segment: Segment,
  emailAddress: string,
  message: string,
  uniqueTabId: string,
  host: string,
) {
  try {
    return await fetchInstance.post(
      `/track/segment/${segment.id}/share`,
      { emailAddress, host, uniqueTabId, message },
    );
  } catch (error) {
    console.log("Fout bij het delen van segment:", error)

    throw error;
  }
}

export const updateSegment = async (
  id: ExplorerItemId,
  segment: Segment,
  uniqueTabId: string,
) => {
  const updatedSegment = {
    id: segment.id,
    startTime: segment.startTime,
    endTime: segment.endTime,
    labelText: segment.labelText,
    description: segment.description,
    editable: segment.editable || false,
    color: segment.color || '#FFFFFF',
  }

  return fetchInstance.post(
    `/track/${id}/segment/${segment.id}/update`,
    {
      segment: updatedSegment,
      uniqueTabId,
    },
  )
}

export async function fetchBandWorkspaceSegmentTags(bandWorkspace: BandWorkspace) {
  return await fetchInstance.get(`/band-workspace-segment-tags/${bandWorkspace.id}`,)
}

export async function fetchSegmentTags(segment: Segment) {
  return await fetchInstance.get(`/segment-tags/${segment.id}`,)
}

export async function createSegmentTag(
  {
    name,
    segment,
    bandWorkspaceId,
    uniqueTabId,
  }:
  {
    name: string | TagOption,
    segment: Segment,
    bandWorkspaceId: number,
    uniqueTabId: string,
  }) {
  return fetchInstance.post(
    `/create-segment-tag/${segment.id}`,
    { bandWorkspaceId, uniqueTabId, name },
  )
}

export async function deleteSegmentTag(
  {
    name,
    segment,
    bandWorkspaceId,
    uniqueTabId,
  }:
  {
    name: string | TagOption,
    segment: Segment,
    bandWorkspaceId: number,
    uniqueTabId: string,
  }) {
  return fetchInstance.delete(
    `/delete-segment-tag/${segment.id}`,
    { bandWorkspaceId, uniqueTabId, name },
  )
}

export async function deleteAllSegmentTags(
  {
    segment,
  }:
  {
    segment: Segment,
  }) {
  return fetchInstance.delete(`/delete-all-segment-tags/${segment.id}`)
}
